import RestApiModel from "@/api/Model/RestApiModel";

class InsuranceType extends RestApiModel {
  static getResourceEndpoint() {
    return '/product-insurance-types-ipr';
  }
}

export default InsuranceType;
